if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");

        const deliveryDatePicker = this.form.querySelector("[name='properties[Delivery date]']");
        if (deliveryDatePicker) {
          deliveryDatePicker.addEventListener("change", this.onDeliveryDateChange.bind(this));
        }

        if (this.form.querySelector("[name=id]")) {
          this.form.querySelector("[name=id]").disabled = false;
        }
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
        this.open = this.getAttribute("open");
      }

      onDeliveryDateChange(evt) {
        const deliveryDateValue = evt.target.value;
        const allItemDeliveryDateProperties = this.form.querySelectorAll(".product__form__delivery-date");
        allItemDeliveryDateProperties.forEach((item) => {
          item.value = deliveryDateValue;
        })
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        if (this.classList.contains("product-form")) {
          const optionWrappers = this.closest("product-info")?.querySelectorAll(
            ".product-form__input:not(.product-variant-colors), [data-variant-select-option-wrapper]:not([data-variant-select-option-wrapper-color])"
          );
          if (optionWrappers) {
            for (let i = 0; i < optionWrappers.length; i++) {
              const selectedInput =
                optionWrappers[i].querySelector("input:checked");
              if (!selectedInput) {
                this.submitButton.querySelector("span").textContent =
                  "Choose size first";
                return;
              }
            }
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.renderCartContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.renderCartContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      renderCartContents(response) {
        const openCart =
          this.open === "cart" ||
          (this.open === "mobile-upsell-desktop-cart" &&
            window.matchMedia("(min-width: 750px)").matches);
        const openUpsell =
          this.open === "upsell" ||
          (this.open === "mobile-upsell-desktop-cart" &&
            window.matchMedia("(max-width: 749px)").matches);

        this.cart.renderContents(response, openCart);
        if (openUpsell) {
          document.querySelector("cart-upsell-popup")?.open();
        }
      }
    }
  );
}
